import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, User, Heart, Search, Menu, X } from "lucide-react";
import { useCart } from "../lib/cart";
import { shopperAuth } from "../lib/shop-api";

export const ShopNavbar = () => {
  const { count } = useCart();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [authed, setAuthed] = useState(shopperAuth.isAuthed());
  const nav = useNavigate();

  useEffect(() => {
    const i = setInterval(() => setAuthed(shopperAuth.isAuthed()), 1000);
    return () => clearInterval(i);
  }, []);

  const links = [
    { to: "/shop", label: "Tienda" },
    { to: "/shop/new", label: "Nuevos" },
    { to: "/shop/sale", label: "Ofertas" },
    { to: "/pages/about", label: "Nosotros" },
    { to: "/pages/shipping", label: "Envíos" },
    { to: "/", label: "Inicio" },
  ];

  const onSearch = (e) => {
    e.preventDefault();
    if (q.trim()) nav(`/shop?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <header className="sticky top-0 z-50 bg-[#0A0908]/95 backdrop-blur border-b border-[#C89B3C]/20">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center gap-4">
        <Link to="/" className="flex items-baseline gap-2 shrink-0" data-testid="shop-brand">
          <span className="text-xl md:text-2xl text-[#F5F0E6]" style={{ fontFamily: "'Playfair Display'", fontWeight: 700 }}>
            El Navegante
          </span>
          <span className="text-[#C89B3C] italic text-sm md:text-base" style={{ fontFamily: "'Playfair Display'" }}>
            Wester
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-6 ml-6">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `text-sm uppercase tracking-wide transition-colors ${isActive ? "text-[#C89B3C]" : "text-[#F5F0E6]/80 hover:text-[#C89B3C]"}`
              }
              data-testid={`shop-nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={onSearch} className="hidden md:flex items-center ml-auto flex-1 max-w-xs">
          <div className="relative w-full">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#F5F0E6]/50" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Buscar..."
              className="w-full bg-white/5 border border-white/10 rounded-full pl-9 pr-3 py-2 text-sm text-[#F5F0E6] placeholder-white/40 focus:border-[#C89B3C] focus:outline-none"
              data-testid="shop-search-input"
            />
          </div>
        </form>

        <div className="flex items-center gap-1 md:gap-2 ml-auto md:ml-2">
          <Link to="/shop/account" className="p-2 hover:bg-white/5 rounded-full text-[#F5F0E6]/90" title={authed ? "Mi cuenta" : "Iniciar sesión"} data-testid="shop-account-link">
            <User size={20} />
          </Link>
          <Link to="/shop/wishlist" className="p-2 hover:bg-white/5 rounded-full text-[#F5F0E6]/90" title="Favoritos" data-testid="shop-wishlist-link">
            <Heart size={20} />
          </Link>
          <Link to="/shop/cart" className="relative p-2 hover:bg-white/5 rounded-full text-[#F5F0E6]/90" title="Carrito" data-testid="shop-cart-link">
            <ShoppingBag size={20} />
            {count > 0 && (
              <span className="absolute -top-0.5 -right-0.5 bg-[#C89B3C] text-[#0A0908] text-[10px] font-bold rounded-full h-4 min-w-4 px-1 flex items-center justify-center" data-testid="cart-count-badge">
                {count}
              </span>
            )}
          </Link>
          <button onClick={() => setOpen((v) => !v)} className="lg:hidden p-2 text-[#F5F0E6]" data-testid="shop-mobile-toggle">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[#0A0908]">
          <div className="px-4 py-3 space-y-2">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="block text-[#F5F0E6]/90 py-2 border-b border-white/5"
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
